import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Admin.css";
import axios from "axios";
import Swal from "sweetalert2";

const LogistikRPLD = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [detailData, setDetailData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        if (!response.data.error) {
          setUserInfo({
            role: response.data.role,
            name: response.data.name,
            full_name: response.data.full_name,
          });
        }
      })
      .catch((error) => console.error("Error user info:", error));

    fetchDetailPanen();
  }, [id]);

  const fetchDetailPanen = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://c-greenproject.org:7500/view_panen_detail_logistik?id=${id}`,
        { withCredentials: true }
      );
      setDetailData(res.data.detail || res.data.panens?.[0] || null);
    } catch (err) {
      console.error("Error loading detail:", err);
      Swal.fire("Error", "Gagal memuat rincian data rencana panen.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.warn("Logout error fallback:", error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  const handleAjukan = async (panenId) => {
    const result = await Swal.fire({
      title: "Ajukan Penanganan Pengiriman",
      text: `Anda yakin ingin mengajukan armada logistik untuk memfasilitasi Rencana Panen #${panenId}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ajukan Sekarang",
      cancelButtonText: "Batal",
      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",
      customClass: {
        confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
        cancelButton: "rounded-pill px-4 fw-medium",
      },
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          "https://c-greenproject.org:7500/ajukan_pengiriman",
          { rencana_panen_id: panenId },
          { withCredentials: true }
        );

        Swal.fire({
          title: "Berhasil!",
          text: response.data.message || "Permohonan pengiriman berhasil diajukan.",
          icon: "success",
          confirmButtonColor: "#198754",
        });
        fetchDetailPanen();
      } catch (error) {
        Swal.fire({
          title: "Gagal",
          text: error.response?.data?.error || "Terjadi kesalahan saat pengajuan.",
          icon: "error",
          confirmButtonColor: "#198754",
        });
      }
    }
  };

  const petani = detailData?.asal_penjemputan || {};
  const pabrik = detailData?.tujuan_pengantaran || {};
  const pengiriman = detailData?.pengiriman || {};
  const canAjukan = !pengiriman.tracking_id && pengiriman.status_logistik === "pending";

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#f8fafc" }}>
      {/* Header */}
      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3" style={{ width: "240px", flexShrink: 0 }}>
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" /> {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/logistik")}
              className="list-group-item text-decoration-none"
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/logistikp")}
              className="list-group-item text-decoration-none"
              style={{ cursor: "pointer" }}
            >
              <img src="/static/shipping.png" alt="Shipping" /> Pengiriman
            </div>
            <div
              onClick={() => navigate("/logistikrp")}
              className="list-group-item text-decoration-none active text-white"
              style={{ cursor: "pointer" }}
            >
              <img src="/static/panen.png" alt="Harvest" /> Rencana Panen
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-grow-1 p-4" style={{ width: "calc(100% - 240px)", overflowX: "hidden" }}>
          
          {/* Top Bar Navigation */}
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
            <div>
              <div className="d-flex align-items-center gap-2 mb-1">
                <button
                  onClick={() => navigate("/logistikrp")}
                  className="btn btn-sm btn-link text-decoration-none p-0 text-muted small"
                >
                  Rencana Panen
                </button>
                <span className="text-muted small">/</span>
                <span className="text-dark small fw-semibold">Rincian Logistik #{id}</span>
              </div>
              <h2 className="fw-bold text-dark mb-0">Rincian Logistik Panen #{id}</h2>
            </div>
            
            <div className="d-flex gap-2">
              {canAjukan && (
                <button
                  className="btn btn-success rounded-pill px-4 shadow-sm fw-semibold"
                  onClick={() => handleAjukan(id)}
                >
                  Ajukan Armada
                </button>
              )}
              <button
                className="btn btn-light bg-white border rounded-pill px-4 shadow-sm fw-medium text-secondary"
                onClick={() => navigate("/logistikrp")}
              >
                ← Kembali
              </button>
            </div>
          </div>

          <div className="divider mb-4"></div>

          {loading ? (
            <div className="text-center py-5 bg-white rounded-4 shadow-sm border p-5">
              <div className="spinner-border text-success" role="status"></div>
              <p className="text-muted mt-2 small">Memuat data rincian logistik...</p>
            </div>
          ) : detailData ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
              
              {/* Baris 1: Grid Asal (Petani) dan Tujuan (Pabrik) */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))", gap: "24px", width: "100%" }}>
                
                {/* Kartu Penjemputan Petani */}
                <div className="bg-white rounded-4 border shadow-sm p-4 d-flex flex-column justify-content-between">
                  <div>
                    <div className="d-flex align-items-center gap-2 pb-3 mb-3 border-bottom">
                      <span className="fs-4">📍</span>
                      <div>
                        <h5 className="fw-bold text-success mb-0">Titik Asal Penjemputan</h5>
                        <small className="text-muted">Informasi petani & lokasi kebun</small>
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                      <div>
                        <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Nama Petani</span>
                        <strong className="text-dark fs-6 text-capitalize">{petani.nama_petani || detailData.nama || "-"}</strong>
                      </div>

                      <div>
                        <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Kontak Petani</span>
                        <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2 rounded-pill font-monospace fw-bold fs-6">
                          📞 {petani.nomor_hp_petani || "-"}
                        </span>
                      </div>

                      <div>
                        <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Alamat Penjemputan Lahan</span>
                        <p className="text-secondary mb-0 small leading-relaxed bg-light p-3 rounded-3 border">
                          {petani.alamat_penjemputan || detailData.alamat || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Kartu Tujuan Pabrik */}
                <div className="bg-white rounded-4 border shadow-sm p-4 d-flex flex-column justify-content-between">
                  <div>
                    <div className="d-flex align-items-center gap-2 pb-3 mb-3 border-bottom">
                      <span className="fs-4">🏭</span>
                      <div>
                        <h5 className="fw-bold text-primary mb-0">Titik Tujuan Bongkar</h5>
                        <small className="text-muted">Pabrik kelapa sawit tujuan</small>
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                      <div>
                        <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Nama Pabrik</span>
                        <strong className="text-dark fs-6 text-capitalize">{pabrik.nama_pabrik || "Belum Ditentukan"}</strong>
                      </div>

                      <div>
                        <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Kontak Pabrik</span>
                        <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 rounded-pill font-monospace fw-bold fs-6">
                          📞 {pabrik.nomor_hp_pabrik || "-"}
                        </span>
                      </div>

                      <div>
                        <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Alamat Pabrik</span>
                        <p className="text-secondary mb-0 small leading-relaxed bg-light p-3 rounded-3 border">
                          {pabrik.alamat_pabrik || "Belum ada informasi alamat pabrik"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* Baris 2: Kartu Parameter Muatan & Status */}
              <div className="bg-white rounded-4 border shadow-sm p-4 w-100">
                <div className="d-flex align-items-center gap-2 pb-3 mb-4 border-bottom">
                  <span className="fs-4">📦</span>
                  <div>
                    <h5 className="fw-bold text-dark mb-0">Informasi Muatan & Rincian Armada</h5>
                    <small className="text-muted">Data tonase, jadwal dan status pengiriman</small>
                  </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "20px" }}>
                  <div className="bg-light p-3 rounded-3 border">
                    <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Estimasi Tonase</span>
                    <h4 className="fw-bold text-success font-monospace mb-0">
                      {(detailData.jumlah_panen_kg || detailData.jumlah_panen || 0).toLocaleString("id-ID")} Kg
                    </h4>
                  </div>

                  <div className="bg-light p-3 rounded-3 border">
                    <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Tanggal Panen</span>
                    <strong className="text-dark fs-6">{detailData.tanggal_panen || "-"}</strong>
                  </div>

                  <div className="bg-light p-3 rounded-3 border">
                    <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Tracking ID</span>
                    <strong className="font-monospace text-dark fs-6">
                      {pengiriman.tracking_id ? `🚚 ${pengiriman.tracking_id}` : "Belum Dibuat"}
                    </strong>
                  </div>

                  <div className="bg-light p-3 rounded-3 border">
                    <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Status Logistik</span>
                    <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-1.5 rounded-pill fw-semibold">
                      {pengiriman.status_logistik || "Pending"}
                    </span>
                  </div>

                  <div className="bg-light p-3 rounded-3 border">
                    <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Jenis Sawit</span>
                    <span className="text-dark fw-medium">{detailData.jenis_sawit || "-"}</span>
                  </div>

                  <div className="bg-light p-3 rounded-3 border">
                    <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Luas Lahan</span>
                    <span className="text-dark fw-medium">{detailData.luas_lahan_ha ? `${detailData.luas_lahan_ha} Ha` : "-"}</span>
                  </div>

                  <div className="bg-light p-3 rounded-3 border">
                    <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Status Validasi Kebun</span>
                    <span className="badge bg-white text-dark border px-2.5 py-1 rounded-pill">
                      {detailData.status_panen || "Diajukan"}
                    </span>
                  </div>

                  <div className="bg-light p-3 rounded-3 border">
                    <span className="text-secondary small fw-semibold text-uppercase d-block mb-1">Rencana Pengiriman</span>
                    <span className="text-dark fw-medium">{pengiriman.tanggal_pengiriman || "-"}</span>
                  </div>
                </div>

                {detailData.catatan && (
                  <div className="mt-4 p-3 bg-danger-subtle rounded-3 border border-danger-subtle">
                    <span className="text-danger fw-bold small d-block mb-1">Catatan / Alasan Penolakan:</span>
                    <p className="mb-0 text-danger small">{detailData.catatan}</p>
                  </div>
                )}
              </div>

            </div>
          ) : (
            <div className="text-center py-5 bg-white rounded-4 shadow-sm border text-muted p-5">
              <span className="fs-1 d-block mb-2">📋</span>
              <h5 className="fw-semibold">Data Tidak Ditemukan</h5>
              <p className="mb-0 small">Rincian rencana panen tidak ditemukan di sistem.</p>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default LogistikRPLD;